// FeedbackDialog.js
import React, { useState, useEffect } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faClose } from '@fortawesome/free-solid-svg-icons';

const FeedbackDialog = ({ showFeedbackDialog, handleFeedbackClose, apiFeedbackUrl, apiAuthKey }) => {
  const [feedbackComment, setFeedbackComment] = useState('');
  const [username, setUsername] = useState('');
  const [email, setEmail] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [feedbackResponseSubmitted, setFeedbackResponseSubmitted] = useState(false);

  const sanitizeInput = (input) => {
    if (typeof input !== 'string') return '';
    return input.replace(/[^\p{L}\p{N}\s]/gu, '');
  };

  useEffect(() => {
    if (showFeedbackDialog || feedbackResponseSubmitted) {
      setUsername('');
      setFeedbackComment('');
      setEmail('');
    }
  }, [showFeedbackDialog]);

  const handleFeedbackSubmit = async (event) => {
    event.preventDefault();
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    if (!feedbackComment) {
      alert('Please enter a comment.');
      return;
    }

    if (!username) {
      alert('Please enter your name.');
      return;
    }

    if (email && !emailRegex.test(email)) {
      alert('Please enter a valid email address or leave blank.');
      return;
    }

    try {
      setIsSubmitting(true);

      const response = await fetch(`${apiFeedbackUrl}`, {
        method: 'POST',
        headers: {
          'Authorization': `${apiAuthKey}`
        },
        body: JSON.stringify({
          "reportDate": new Date().toISOString(),
          "username": sanitizeInput(username),
          "email": email,
          "url": window.location.href,
          "comment": sanitizeInput(feedbackComment)
        })
      });
      setFeedbackResponseSubmitted(true);
      setTimeout(handleFeedbackClose, 4000);
      setTimeout(() => {
        setFeedbackResponseSubmitted(false);
       }, 4000);
      
    } catch (error) {
      console.error('Error posting feedback:', error);
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    showFeedbackDialog && (
      <div className="dialog-left-overlay">
        <div className="dialog">
          <button className="close-btn" onClick={handleFeedbackClose}><FontAwesomeIcon icon={faClose} /></button>
          {!feedbackResponseSubmitted ? (
            <form onSubmit={handleFeedbackSubmit}>
              <p className="prompt-text">Found a mistake? Any ideas on making it better? Feedback is welcome here.</p>
              <textarea
                value={feedbackComment}
                onChange={(e) => setFeedbackComment(e.target.value)}
                placeholder="Enter your comment (max 255 chars)"
                maxLength="255"
              />
              <input
                value={username}
                onChange={(e) => setUsername(e.target.value)}
                placeholder="Enter your name (max 50 chars)"
                maxLength="50"
              />
              <input
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="Enter your email (optional)"
              />
              <button
                type="submit"
                disabled={isSubmitting}
                className="note-btn"
              >
                {isSubmitting && <span className="spinner" />}
                {isSubmitting ? '' : 'Add Note'}
              </button>
            </form>
          ) : (
            <p>Thank you for your feedback!</p>
          )}
        </div>
      </div>
    )
  );
};

export default FeedbackDialog;
